module.exports = __webpack_public_path__ + "img/album07_20.428ede25.jpg";